<div class="sp-width__full sp-grid__summary-5 sp-grid__gap sp-overflow__x-scroll">
  <app-shared-summary-item
    [item_label]="'STEPS.SUMMARY_ALL_LABEL'"
    [item_value]="summary?.length?.toString() || '0'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'STEPS.SUMMARY_PENDING_LABEL'"
    [item_value]="summary?.pending?.toString() || '0'"
    [item_class]="'sp-orders__status-pending'"
    [label_class]="'sp-color__primary'"
    [value_class]="'sp-color__primary'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'STEPS.SUMMARY_COMPLETED_LABEL'"
    [item_value]="summary?.completed?.toString() || '0'"
    [item_class]="'sp-orders__status-completed'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'STEPS.SUMMARY_REFUNDED_LABEL'"
    [item_value]="summary?.refunded?.toString() || '0'"
    [item_class]="'sp-orders__status-refunded'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'STEPS.SUMMARY_CANCELED_LABEL'"
    [item_value]="summary?.canceled?.toString() || '0'"
    [item_class]="'sp-orders__status-canceled'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
</div>
